// extracted by mini-css-extract-plugin
export default {"Control":"Control_Control__0XmX7"};